const localFakeVideos = [
  '2020-11-12 19-15-36.mp4',
  '2020-11-12 19-17-08.mp4',
  '2020-11-12 19-18-48.mp4',
  '2020-11-12 19-22-26.mp4',
  '2020-11-12 19-28-32.mp4',
  '2020-11-12 19-29-01.mp4',
  '2020-11-12 19-29-34.mp4',
  '2020-11-12 19-40-20.mp4',
  '2020-11-12 19-47-43.mp4',
  '2020-11-12 19-53-40.mp4',
];

const npcVideos = [
  'NPC_Discoball.mp4',
  'NPC_Gisela.mp4',
  'NPC_Kristi.mp4',
  'NPC_Empty_desk1.mp4',
  'NPC_Jared.mp4',
  'NPC_Lara.mp4',
];

const fakeVideos = [
  '2020-11-12 19-15-36.mp4',
  '2020-11-12 19-16-33.mp4',
  '2020-11-12 19-17-08.mp4',
  '2020-11-12 19-18-48.mp4',
  '2020-11-12 19-21-23.mp4',
  '2020-11-12 19-22-26.mp4',
  '2020-11-12 19-24-25.mp4',
  '2020-11-12 19-24-37.mp4',
  '2020-11-12 19-27-55.mp4',
  '2020-11-12 19-28-32.mp4',
  '2020-11-12 19-29-01.mp4',
  '2020-11-12 19-29-34.mp4',
  '2020-11-12 19-30-29.mp4',
  '2020-11-12 19-36-08.mp4',
  '2020-11-12 19-37-14.mp4',
  '2020-11-12 19-40-20.mp4',
  '2020-11-12 19-42-27.mp4',
  '2020-11-12 19-42-59.mp4',
  '2020-11-12 19-44-32.mp4',
  '2020-11-12 19-46-15.mp4',
  '2020-11-12 19-47-43.mp4',
  '2020-11-12 19-48-29.mp4',
  '2020-11-12 19-49-39.mp4',
  '2020-11-12 19-52-08.mp4',
  '2020-11-12 19-53-40.mp4',
  '2020-11-12 19-54-53.mp4',
  '2020-11-12 19-57-23.mp4',
  '2020-11-12 19-58-51.mp4',
  '2020-11-12 20-00-04.mp4',
  '2020-11-12 20-00-31.mp4',
  '2020-11-12 20-00-58.mp4',
  '2020-11-12 20-01-45.mp4',
  '2020-11-12 20-02-59.mp4',
  '2020-11-12 20-03-50.mp4',
  '2020-11-12 20-04-27.mp4',
  '2020-11-12 20-05-01.mp4',
  '2020-11-12 20-06-31.mp4',
  '2020-11-12 20-07-02.mp4',
  '2020-11-12 20-07-19.mp4',
  '2020-11-12 20-09-04.mp4',
  '2020-11-12 20-10-19.mp4',
  '2020-11-12 20-13-02.mp4',
  '2020-11-12 20-13-44.mp4',
  '2020-11-12 20-15-43.mp4',
  '2020-11-12 20-18-28.mp4',
  '2020-11-12 20-18-47.mp4',
  '2020-11-12 20-19-38.mp4',
  '2020-11-12 20-20-57.mp4',
  '2020-11-12 20-21-46.mp4',
  '2020-11-12 20-23-18.mp4',
  '2020-11-12 20-23-42.mp4',
  '2020-11-12 20-24-39.mp4',
  '2020-11-12 20-25-55.mp4',
  '2020-11-12 20-26-17.mp4',
  '2020-11-12 20-27-36.mp4',
  '2020-11-12 20-28-45.mp4',
  '2020-11-12 20-29-03.mp4',
  '2020-11-12 20-30-58.mp4',
  '2020-11-12 20-31-51.mp4',
  '2020-11-12 20-33-00.mp4',
  '2020-11-12 20-33-58.mp4',
  '2020-11-12 20-34-13.mp4',
  '2020-11-12 20-34-42.mp4',
  '2020-11-12 20-35-13.mp4',
  '2020-11-12 20-35-30.mp4',
  '2020-11-12 20-36-21.mp4',
  '2020-11-12 20-37-25.mp4',
  '2020-11-12 20-38-12.mp4',
  '2020-11-12 20-39-49.mp4',
  '2020-11-12 20-41-32.mp4',
  '2020-11-12 20-42-04.mp4',
  '2020-11-12 20-42-30.mp4',
  '2020-11-12 20-42-49.mp4',
  '2020-11-12 20-44-07.mp4',
  '2020-11-12 20-44-35.mp4',
  '2020-11-12 20-45-25.mp4',
  '2020-11-12 20-46-52.mp4',
  '2020-11-12 20-47-58.mp4',
  '2020-11-12 20-48-54.mp4',
  '2020-11-12 20-50-10.mp4',
  '2020-11-12 20-50-56.mp4',
  '2020-11-12 20-58-12.mp4',
  '2020-11-12 21-02-50.mp4',
  '2020-11-12 21-03-26.mp4',
  '2020-11-12 21-05-19.mp4',
  '2020-11-12 21-08-02.mp4',
  '2020-11-12 21-08-39.mp4',
  '2020-11-12 21-09-02.mp4',
  '2020-11-12 21-09-34.mp4',
  '2020-11-12 21-10-07.mp4',
  '2020-11-12 21-10-45.mp4',
  '2020-11-12 21-11-41.mp4',
  '2020-11-12 21-13-55.mp4',
];

export { fakeVideos, localFakeVideos, npcVideos };
